export const imagesPrompts = {
  removeBackground: "Сделай фон однотонным, нейтрального цвета, на котором изображение будет чётко видно",
  changeBackground:
    "Выбери фон, подходящий для этого товара. Можно сделать орнамент, или какой-то материал. Выбери, основывась на том, что это за товар и где он будет лучше выглядеть",
  enhanceQuality: "Сделай изображение более продающим и привлекательным. Подбери подходящую для этого товара стилистику",
  addText: "Добавь на изображение подходящий текст",
};
